import { render, staticRenderFns } from "./feedBait_page1.vue?vue&type=template&id=5c0925c4&scoped=true"
import script from "./feedBait_page1.vue?vue&type=script&lang=js"
export * from "./feedBait_page1.vue?vue&type=script&lang=js"
import style0 from "./feedBait_page1.vue?vue&type=style&index=0&id=5c0925c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0925c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0925c4')) {
      api.createRecord('5c0925c4', component.options)
    } else {
      api.reload('5c0925c4', component.options)
    }
    module.hot.accept("./feedBait_page1.vue?vue&type=template&id=5c0925c4&scoped=true", function () {
      api.rerender('5c0925c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/feeder/feedBait_page1.vue"
export default component.exports